export const toLearnList = [
    "React Context",
    "Node.js",
    "Cypress",
    "Unit testing",
    "TypeScript",
    "JS classes",
];